import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class LocationService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
	}

	public get(gcp) {
		var filter = "";
		if (gcp) {
			filter = "&gcp=" + gcp;
		}
		return this.http.get(environment.apiurl + "/Locations/all?access_token=" + this.globalCfgService.getAccessToken() + filter);
	}

	public locationSummary(obj) {
		return this.http.post(environment.apiurl + "/Locations/allSummary?access_token=" + this.globalCfgService.getAccessToken() , obj);
	}

	public getByMedicine(id) {
		return this.http.get(environment.apiurl + "/Locations/byMedicine/" + id + "?access_token=" + this.globalCfgService.getAccessToken());
	}

	public getList(gcp) {
		var filter = "";
		if (gcp) {
			filter = "&gcp=" + gcp;
		}
		return this.http.get(environment.apiurl + "/Locations/list?access_token=" + this.globalCfgService.getAccessToken() + filter);
	}

	public add(rec) {
		return this.http.post(environment.apiurl + "/Locations/add?access_token=" + this.globalCfgService.getAccessToken(), rec)
	}

	public update(rec) {
		return this.http.post(environment.apiurl + "/Locations/update?access_token=" + this.globalCfgService.getAccessToken(), rec)
	}
}

	

